import BaseApi from './base.api'

class ScheduleApi extends BaseApi {
  eventsUrl = 'events/'
  eventWarningsUrl = 'event-warnings/'
  taskTypesUrl = 'task-types/'
  tasksUrl = 'tasks/'

  getEventsAsync = (params) => this.getAsync(this.eventsUrl, params)
  getEventWarningsAsync = (params) => this.getAsync(this.eventWarningsUrl, params)
  getEventsByServiceAsync = (serviceId, params) => this.getAsync(this.eventsUrl, {
    ...params,
    service: serviceId
  })
  getEventsByServiceIdsAsync = (serviceIds, params) => this.getAsync(this.eventsUrl, {
    ...params,
    service_ids: serviceIds.join(','),
  })
  getEventsByServiceForProjectAsync = (projectId) => this.getAsync(`${this.eventsUrl}by-service/`, { project: projectId })
  getProjectEventsAsync = (params) => this.getAsync(this.eventsUrl, { ...params, project_only: true })
  getEventsByDayThenProjectAsync = (params) => this.getAsync(`${this.eventsUrl}by-day-then-project/`, params)
  getMissingResourcesSummaryAsync = () => this.getAsync(`${this.eventsUrl}missing-resources-summary/`)
  getConflictsSummaryAsync = () => this.getAsync(`${this.eventsUrl}conflicts-summary/`)
  getReplacementCandidatesAsync = (budgetDocumentRowId) =>
    this.getAsync(`${this.eventsUrl}replacement-candidates/`, { budget_document_row: budgetDocumentRowId })
  replaceServiceAsync = (budgetDocumentRowId, serviceId) =>
    this.postAsync(`${this.eventsUrl}replace-service/`, { budget_document_row: budgetDocumentRowId, service: serviceId })
  getTimelineAsync = (start, end, projectIds) => this.getAsync(`${this.eventsUrl}timeline/`, {
    start,
    end,
    ...(projectIds?.length && { project_ids: projectIds.join(',') }),
  })

  upsertEventAsync = (data, config) => this.upsertAsync(this.eventsUrl, data, config)

  syncRangeAsync = (serviceId, projectId, start, end, { quantity, listingId, budgetDocumentRowId, selectedComponentIds } = {}, config) =>
    this.postAsync(`${this.eventsUrl}sync-range/`, {
      service: serviceId,
      project: projectId,
      start,
      end,
      quantity: quantity ?? 1,
      listing: listingId,
      ...(budgetDocumentRowId != null && { budget_document_row: budgetDocumentRowId }),
      ...(selectedComponentIds != null && { selected_component_ids: selectedComponentIds }),
    }, config)

  updateRangeAsync = (projectId, start, end, { serviceId, budgetDocumentRowId, updatePlanned, shift } = {}) =>
    this.postAsync(`${this.eventsUrl}update-range/`, {
      project: projectId,
      start,
      end,
      ...(budgetDocumentRowId != null && { budget_document_row: budgetDocumentRowId }),
      ...(serviceId != null && { service: serviceId }),
      ...(updatePlanned && { update_planned: true }),
      ...(shift && { shift: true }),
    })

  deleteRangeAsync = (budgetDocumentRowId, { serviceId, projectId, updatePlanned } = {}) =>
    this.deleteAsync(`${this.eventsUrl}delete-range/`, {
      params: {
        ...(budgetDocumentRowId != null && { budget_document_row: budgetDocumentRowId }),
        ...(serviceId != null && { service: serviceId }),
        ...(projectId != null && { project: projectId }),
        ...(updatePlanned && { update_planned: true }),
      },
    })

  deleteEventAsync = (eventId, { updatePlanned } = {}) =>
    this.deleteAsync(`${this.eventsUrl}${eventId}/`, {
      params: { ...(updatePlanned && { update_planned: true }) },
    })

  // serviceId null confirms all in scope; budgetDocumentRowId scopes to one row (group).
  // force=true confirms services without stock too (availability goes negative).
  confirmAllocationAsync = (serviceId, projectId, allocations = [], budgetDocumentRowId = null, force = false, config = undefined) =>
    this.postAsync(`${this.eventsUrl}confirm-allocation/`, {
      service_id: serviceId,
      project_id: projectId,
      allocations,
      budget_document_row_id: budgetDocumentRowId,
      force,
    }, config)

  // serviceId null cancels all in scope; budgetDocumentRowId scopes to one row (group).
  cancelAllocationAsync = (serviceId, projectId, budgetDocumentRowId = null) =>
    this.postAsync(`${this.eventsUrl}cancel-allocation/`, {
      service_id: serviceId,
      project_id: projectId,
      budget_document_row_id: budgetDocumentRowId,
    })

  reorderTasksAsync = (taskIds) => this.postAsync(`${this.tasksUrl}reorder/`, { ids: taskIds })
  reorderTaskTypesAsync = (taskTypeIds) => this.postAsync(`${this.taskTypesUrl}reorder/`, { ids: taskTypeIds })
}

export const scheduleApi = new ScheduleApi('schedule/')
